export default __webpack_public_path__ + "static/media/admin_goals.31d6cbf2.svg";